export const REASONS = [
  'Unknown charge on my card',
  'Find out what site charged me',
  'Request a refund',
  'Other',
] as const

export type Reasons = typeof REASONS[number]
